import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizeFirst',
    standalone: true
})
export class CapitalizeFirstPipe implements PipeTransform {
    transform(s: string): string {
      if (!s || typeof s !== 'string') return ''
      return s[0].toLocaleUpperCase() + s.slice(1,s.length);
    }
}
